import { ADD_CANDIDATE_FORM_FIELD_NAMES } from '../../components/app/AddCandidate/AddCandidateForm';

const capitalise = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1);

const getTotalMonths = (years = 0, months = 0) => {
  const yearsInMonths = years * 12;
  return yearsInMonths + months;
};
const constructManualCandidateFormData = (
  positionId: number,
  candidate: any,
) => {
  const data = new FormData();

  if (candidate.timeInRoleYears === '' && candidate.timeInRoleMonths === '') {
    data.append('Candidate.MostRecentRoleMonths', '');
  } else {
    data.append(
      'Candidate.MostRecentRoleMonths',
      getTotalMonths(
        Number(candidate.timeInRoleYears),
        Number(candidate.timeInRoleMonths),
      ).toString(),
    );
  }
  ['resume', 'coverLetter'].forEach((key) => {
    const attachment = candidate[key];
    const paramKey = capitalise(key);
    const { previousAttachment = null, file = null } = attachment || {};
    if (file) {
      data.append(paramKey, file);
    }
    if (previousAttachment) {
      data.append(
        `Candidate.Previous${paramKey}.ProspectID`,
        previousAttachment.prospectId,
      );
      data.append(
        `Candidate.Previous${paramKey}.AttachmentID`,
        previousAttachment.attachmentId,
      );
    }
  });
  data.append('PositionID', positionId.toString());
  [
    ADD_CANDIDATE_FORM_FIELD_NAMES.EMAIL,
    ADD_CANDIDATE_FORM_FIELD_NAMES.FIRST_NAME,
    ADD_CANDIDATE_FORM_FIELD_NAMES.LAST_NAME,
    ADD_CANDIDATE_FORM_FIELD_NAMES.PHONE,
    ADD_CANDIDATE_FORM_FIELD_NAMES.MOST_RECENT_JOB_TITLE,
    ADD_CANDIDATE_FORM_FIELD_NAMES.MOST_RECENT_COMPANY_NAME,
    ADD_CANDIDATE_FORM_FIELD_NAMES.NOTES,
  ].forEach((key) => {
    data.append(`Candidate.${capitalise(key)}`, candidate[key]);
  });
  data.append(
    'Candidate.OriginID',
    candidate[ADD_CANDIDATE_FORM_FIELD_NAMES.ORIGIN_ID],
  );
  return data;
};

export default constructManualCandidateFormData;
